var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-right"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"id":"Desktop","transform":"translate(-106.000000, -1653.000000)","stroke":"#AD06FF","strokeWidth":"2"},React.createElement("g",{"id":"arrow-right","transform":"translate(107.000000, 1654.000000)"},[React.createElement("path",{"d":"M0,8.5 L17,8.5","id":"Path","key":0}),React.createElement("polyline",{"id":"Path","points":"8 0 17 8.5 8 17","key":1})])))]);
}

Arrow.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
